import { render } from "./dialogCard.vue?vue&type=template&id=0483d9a8"
import script from "./dialogCard.vue?vue&type=script&lang=js"
export * from "./dialogCard.vue?vue&type=script&lang=js"

import "./dialogCard.vue?vue&type=style&index=0&id=0483d9a8&lang=scss&scope=true"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_8601aa9edf40feba5c1f16c508af6bdf/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__